<template>
  <div class="search-results-page">
    <div class="search-results-container">
      <h1 class="page-header color-1-100">
        Search results for "<i>{{this.$route.query.search}}</i>"
      </h1>
      <div class="content-section">
        <div class="search">
          <div class="search-filter">
            <v-select placeholder="Filter by Type"
                      value.sync="selectedType"
                      :on-change="selectType"
                      :options="getContentTypeForSelect">
            </v-select>
          </div>
          <div class="search-result">
            <ul class="search-result-main">
              <li v-for="item in items" class="search-result-main-item" :class="itemClass(item.content_type.type)">
                <router-link class="search-result-main-item-href" :to="{ name: 'content', params: {id: item.id} }">
                  {{ item.title }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="load-more-container" v-if="this.noMore === false">
            <div class="load-more-btn" @click="loadMore()">
              <div id="wave"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>Load more
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'search-results',
  data () {
    return {
      ppt: 5,
      noMore: false,
      items: [],
      page: 1,
      moreResults: false,
      server: api.serverURL,
      selectedType: null,
      selectedTags: null,
      aldItems: []
    }
  },
  computed: {
    ...mapGetters([
      'selectedHightCont',
      'getContentTypeForSelect',
      'getTagTitles'
    ])
  },
  beforeRouteUpdate (to, from, next) {
    this.page = 1
    this.name = to.params.name
    next()
    this.fetchContent()
  },
  methods: {
    fetchContent () {
      let queryString = `${api.URLS.search}&page=${this.page}&size=${this.ppt}`
      if (this.$route.query.search) {
        queryString += `&search=${this.$route.query.search}`
      }
      if (this.selectedType) {
        queryString += `&contentType[0]=${this.selectedType}`
      }
      if (this.selectedTags) {
        queryString += `&tags[]=${this.selectedTags}`
      }
      this.$eventHub.$emit('load-end')
      this.$http.get(`${queryString}`, api.headersAuthSettings).then((res) => {
        let resData = res.body.data
        if (res.body.data.success) {
          this.$eventHub.$emit('load-end')
          this.$eventHub.$emit('load-stop')
          this.noMore = true
        } else {
          this.$eventHub.$emit('load-start')
          if (this.page === 1) {
            this.items = res.body.data.items
          } else {
            this.items = [...this.items, ...res.body.data.items]
          }
          if (this.items.length < this.ppt) {
            this.noMore = true
          }
          this.moreResults = resData.page
        }
      }).catch((err) => console.error(err))
    },
    selectType (val) {
      if (val) {
        this.selectedType = val.value
      } else {
        this.selectedType = null
      }
      this.items = []
      this.page = 1
      this.noMore = false
      if (window._paq) {
        let filterLabel = this.getContentTypeForSelect.find((item) => item.value === this.selectedType)
        window._paq.push(['trackEvent', 'Search', 'filter', filterLabel.label])
      }
      // if (window.ga) {
      //   let filterLabel = this.getContentTypeForSelect.find((item) => item.value === this.selectedType)
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: filterLabel.label,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
      this.fetchContent()
    },
    selectTags (val) {
      if (val) {
        this.selectedTags = val.value
      } else {
        this.selectedTags = null
      }
      this.fetchContent()
    },
    nextPage () {
      this.page = this.page + 1
      this.fetchContent()
    },
    itemClass (type) {
      return type.toLowerCase().replace(/\s/g, '')
    },
    loadMore () {
      this.nextPage()
      if (window._paq) {
        window._paq.push(['trackEvent', 'Search', 'filter', 'load more'])
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: 'load more',
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    }
  },
  mounted () {
    this.page = 1
    this.fetchContent()
  },
  watch: {
    '$route' (to, from) {
      if (to.query['content-type'] && to.query['content-type'] !== from.query['content-type']) {
        let selected = this.getContentTypeForSelect.find((item) => item.value === to.query['content-type'])
        this.selectedType = {
          value: selected.value,
          label: selected.label
        }
      }
    }
  }
}
</script>

<style src="@/assets/scss/main/searchResults.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// SearchResults.vue?7cd2d791